import useCustomRouter from 'hooks/useCustomRouter';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { TabPanel } from 'primereact/tabview';
import React from 'react';
import { useParams } from 'react-router';
import useDetallePoliza from 'redux/hooks/useDetallePoliza';

const PlanesSeleccionadosPoliza = () => {
  const { poliza } = useDetallePoliza();
  const router = useCustomRouter();
  const { idPoliza } = useParams();

  const getCertificados = (rowData) => async () => {
    router.push(`/detalle-poliza-plan/${idPoliza}/${rowData?.planCodigo}`);
  };

  const body = (rowData) => {
    return (
      <button
        className="btn btn-primary btn-sm btn-block"
        onClick={getCertificados(rowData)}
      >
        Certificados
      </button>
    );
  };

  return (
    <TabPanel header="Planes Seleccionados" headerStyle={{ fontSize: '20px' }}>
      <div className="container-fluid">
        <div className="row">
          <div className="col-12">
            <DataTable
              value={poliza?.polItems}
              className="p-datatable-gridlines p-datatable-sm"
              rowHover
              emptyMessage="No hay planes contratados"
              resizableColumns
              autoLayout
            >
              <Column
                header="Nombre"
                sortable
                className="text-center"
                field="planNombre"
              />
              <Column
                header="Días Contratados"
                sortable
                className="text-center"
                field="diasNumero"
              />
              <Column
                header="Días restantes"
                sortable
                className="text-center"
                field="diasRestante"
              />
              <Column
                header="Prima Neta"
                sortable
                className="text-center"
                field="valorTotal.primaNeta"
              />
              <Column
                header="Impuestos Total"
                sortable
                className="text-center"
                field="valorTotal.impuestosTotal"
              />
              <Column
                header="Prima Total"
                sortable
                className="text-center"
                field="valorTotal.primaTotal"
              />
              <Column header="Certificados" body={body} />
            </DataTable>
          </div>
        </div>
      </div>
    </TabPanel>
  );
};

export default PlanesSeleccionadosPoliza;
